import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DxTreeViewComponent } from 'devextreme-angular';
import { Apiservice } from '../../../services/api.service';
import { alert } from 'devextreme/ui/dialog';


@Component({
  selector: 'app-crm-vista-procedure-contatti',
  templateUrl: './crm-vista-procedure-contatti.component.html',
  styleUrls: ['./crm-vista-procedure-contatti.component.css']
})
export class CrmVistaProcedureContattiComponent implements OnInit {
  @ViewChild("treeView", { static: false }) treeView: DxTreeViewComponent

  @Input() queryString = ''
  @Input() filterEditor = ''
  @Input() detailVisible: boolean = false;
  @Input() classeTreeView: string = ''
  @Input() classeTreeDetail: string = ''
  @Input() heightTree: number | undefined
  @Input() widthTree: number | undefined
  @Input() heightDetail: string | undefined
  @Input() widthDetail: string | undefined
  @Input() focusStateEnabled: boolean = false;
  @Input() btnTooltip: boolean = true
  @Input() collassabile: boolean = true;
  public datiProcedure: any = [];
  public currentItem: any;
  tooltipData: { [key: string]: any } = {}
  constructor(private apiService: Apiservice,) { }

  ngOnInit(): void {
    if (this.queryString && this.queryString !== '') {
      this.getProcedureContatti();
    } else {
      /* alert("Errore nell'ID del Contatto", 'Errore') */
    }
  }

  async getProcedureContatti() {
    try {
      this.datiProcedure = await this.apiService.GetApiRest(`getAllProcedureByContatto${this.queryString}`);
      this.setExpandedForParents(this.datiProcedure);
      // console.log('espanso di default');
      // this.getItemTemplate(this.datiProcedure);
      // console.log('attivazione del dxTemplate');
      //console.log('Dati ricevuti:', this.datiProcedure);
      return true
    } catch (error) {
      alert("Errore nel caricamento delle procedure del contatto", 'Errore')
      this.datiProcedure = [];
      return false
    }
  }

  setExpandedForParents(items: any[]): void {
    //info crea un ciclo dove gli item che hanno i figli (item.moduli) sono espansi 
    items.forEach(item => {
      if (item.moduli && item.moduli.length > 0) {
        item.expanded = true;
        //info una volta che item è espenso se è diverso da currentItem, diventa item (prendi il primo nodo padre e fai visualizzare i dettagli) 
        if (!this.currentItem) {
          this.currentItem = item;
          //console.log("Primo nodo padre impostato:", this.currentItem);
        }
        //this.setExpandedForParents(item.moduli);
        //console.log('item padre espanso');
      }
    });
  }

  //info in questa funzione se l'item è espanso, allora avvia il collapseItem()
  onTreeItemClick(e: any) {
    this.currentItem = e.itemData;
    const key = e.itemData.id;
    console.log("evento:", e);
    if (this.collassabile) {
      if (e.node.expanded) {
        this.treeView.instance.collapseItem(key);
        //console.log('collassato:', key);
      } else {
        this.treeView.instance.expandItem(key);
        //console.log('espanso:', key);
      }
    }

  }
  getDimensioniDetail() {
    return {
      height: this.heightDetail && this.heightDetail !== '' ? this.heightDetail : undefined,
      width: this.widthDetail && this.widthDetail !== '' ? this.widthDetail : undefined
    };
  }
}


